<div class="container">
    <div class="row">
        <div class="col">
            <div class="jumbotron w-100">
                <h1 class="text-capitalize">{{ params()['users-title'] }}</h1>
                <p>Ci sono {{ get().length + " " + params()['users-title'] }} registrati nel sistema</p>
                <button type="button" class="btn btn-primary" (click)="handleModal(undefined, 'create')">Aggiungi</button>
                <button type="button" class="btn btn-primary ml-2" (click)="openImport()">Import massivo</button>
            </div>
        </div>
    </div>


    <div class="row mb-3">
        <div class="col">
            <input type="text" class="form-control" id="filter_text" name="filter_text" placeholder="Filtro di ricerca" [(ngModel)]="temp.filter_text">
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div [hidden]="!get().length && !temp.filter_text" class="table-responsive-md">
                <table class="table">
                    <thead class="thead-primary">
                        <tr>
                            <th scope="col">Nome</th>
                            <th scope="col">Telefono</th>
                            <th scope="col">Email</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="table-row cursor-pointer" *ngFor="let user of get(); index as i" (click)="handleModal(user.public_token, 'update')">
                            <td scope="col">{{ user.public_configuration.nome }}</td>
                            <td scope="col">{{ user.public_configuration.telefono }}</td>
                            <td scope="col">{{ user.email }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<span id="userModal">
    <div class="modal-backdrop fade show" style="display: none;"></div>
    <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ !!getUser().public_token ? 'Aggiorna' : 'Aggiungi' }}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="handleModal(undefined, undefined)">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">

                <form>
                    <div class="form-row" [hidden]="!getUser().public_token">
                        <div class="form-group col-md-6">
                            <label for="type">Tipo di utente</label>
                            <select name="type_select" id="type_select" class="form-control" [(ngModel)]="getUser().public_configuration.type" (change)="handleUser()">
                                <option value="cliente">Cliente</option>
                                <option value="dipendente">Dipendente</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <input type="text" class="form-control" id="username" name="username" placeholder="Username" [(ngModel)]="getUser().username">
                        </div>
                        <div class="form-group col-md-6">
                            <input type="password" class="form-control" id="password" name="password" placeholder="Password" [(ngModel)]="getUser().password">
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <input type="text" class="form-control" id="email" name="email" placeholder="Email" [(ngModel)]="getUser().email">
                        </div>
                        <div class="form-group col-md-6">
                            <input type="text" class="form-control" id="telefono" name="telefono" placeholder="Telefono" [(ngModel)]="getUser().public_configuration.telefono">
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <input type="text" class="form-control" id="codice_fiscale" name="codice_fiscale" placeholder="Codice fiscale" [(ngModel)]="getUser().public_configuration.codice_fiscale">
                        </div>
                        <div class="form-group col-md-6">
                            <input type="text" class="form-control" id="p_iva" name="p_iva" placeholder="Partita IVA" [(ngModel)]="getUser().public_configuration.p_iva">
                        </div>
                    </div>

                    <div class="form-group">
                        <input type="text" class="form-control" id="ragione_sociale" name="ragione_sociale" placeholder="Mario Rossi / Rossi srl" [(ngModel)]="getUser().public_configuration.nome">
                    </div>

                    <div class="form-row">
                        <div class="form-group col-sm-12 col-md-6">
                            <input type="text" class="form-control col-12" id="codice_utente" name="codice_utente" placeholder="Codice utente" [(ngModel)]="getUser().public_configuration.codice">
                            <button type="button" class="btn btn-primary btn-block mt-2" (click)="getUser().public_configuration.codice = rand()">Genera codice</button>
                        </div>
                        <div class="form-group col-sm-12 col-md-6">
                            <input type="text" class="form-control col-12" id="indirizzo_autocomplete" placeholder="Indirizzo">

                            <ul class="list-group mt-2" *ngFor="let address of getUser().public_configuration.indirizzo; index as i">
                                <li class="list-group-item">
                                    <button type="button" class="close" aria-label="Close" (click)="deleteAddress(i)">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    {{ address.formatted_address }}
                                </li>
                            </ul>
                        </div>
                    </div>
                    
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="type">Aggiungi gruppo</label>
                            <select name="group_select" id="group_select" class="form-control" (change)="addGroup($event)">
                                <option value="">-</option>
                                <option [value]="group.id" *ngFor="let group of window.usher.get()?.public_configuration?.groups; index as i">{{ group.name }}</option>
                            </select>
                        </div>
                        <div class="form-group col-md-6">
                            <ul>
                                <li *ngFor="let group of getUser().public_configuration?.groups; index as i">{{ group.name }}<span (click)="getUser().public_configuration.groups.splice(i, 1)" class="float-right cursor-pointer"><i class="fas fa-trash"></i></span></li>
                            </ul>
                        </div>
                    </div>

                    <div class="form-row" *ngIf="!getUser().public_token">
                        <div class="col">
                            <div class="form-group form-check mt-3">
                                <input type="checkbox" class="form-check-input" id="password_change" name="password_change" [(ngModel)]="temp.password_change">
                                <label class="form-check-label" for="password_change">Cambio password al primo login</label>
                            </div>
                        </div>
                    </div>
                </form>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" (click)="handleUser()">{{ !!getUser().public_token ? 'Aggiorna' : 'Aggiungi' }}</button>
              <button type="button" class="btn btn-danger" (click)="handleModal(getUser().public_token, 'delete')" [hidden]="!getUser().public_token">Elimina</button>
              <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="handleModal(undefined, undefined)">Chiudi</button>
            </div>
          </div>
        </div>
    </div>
</span>

<span id="deleteUserModal">
    <div class="modal-backdrop fade show" style="display: none;"></div>
    <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-sm" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Elimina</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="handleModal(getUser().public_token, 'update')">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                Sei sicuro di voler eliminare questo utente?
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" (click)="delete()">Elimina</button>
              <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="handleModal(getUser().public_token, 'update')">Chiudi</button>
            </div>
          </div>
        </div>
    </div>
</span>

<span id="importModal">
    <div class="modal-backdrop fade show" style="display: none;"></div>
    <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Import utenti</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeImport()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                <p>In questa sezione potrai effettuare l'import massivo tramite file CSV/XLS/XLSX.</p>
                <p>Per poter effettuare quest'operazione dovrai caricare un file nel formato sopra elencato, formattato esattamente come quello di esempio.</p>
                <button type="button" class="btn btn-sm btn-outline-primary mb-3" (click)="downloadEsempioImport()">Scarica file di esempio</button>
                <p class="mb-3">
                    <label for="inputImport" class="cursor-pointer label-link">Se hai gi&agrave; il file formattato nel modo corretto, procedi con il caricamento.</label>
                    <input (change)="getImportDocument($event)" type="file" hidden id="inputImport" name="inputImport" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
                </p>

                <p [hidden]="!show_import_correct">File letto correttamente. Sono inseribili {{ array_import.length }} utenti nel sistema.</p>

                <div class="row" [hidden]="!show_import_correct">
                    <div class="col">
                        <div class="table-responsive-md">
                            <table class="table">
                                <thead class="thead-primary">
                                    <tr>
                                        <th scope="col">Username</th>
                                        <th scope="col">Email</th>
                                        <th scope="col">Telefono</th>
                                        <th scope="col">Elimina</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="table-row" *ngFor="let user of array_import; index as i">
                                        <td scope="col">{{ user.username }}</td>
                                        <td scope="col">{{ user.email }}</td>
                                        <td scope="col">{{ user.telefono }}</td>
                                        <td scope="col"><button type="button" class="btn btn-outline-danger" (click)="array_import.splice(i, 1)"><i class="fa fa-trash"></i></button></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" (click)="uploadImport()">Aggiungi</button>
              <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeImport()">Chiudi</button>
            </div>
          </div>
        </div>
    </div>
</span>